import { render, staticRenderFns } from "./CompareModal.vue?vue&type=template&id=4377dade&scoped=true"
import script from "./CompareModal.vue?vue&type=script&lang=ts"
export * from "./CompareModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4377dade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4377dade')) {
      api.createRecord('4377dade', component.options)
    } else {
      api.reload('4377dade', component.options)
    }
    module.hot.accept("./CompareModal.vue?vue&type=template&id=4377dade&scoped=true", function () {
      api.rerender('4377dade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/CompareModal.vue"
export default component.exports